export default function () {
    function getTimeFromOrder(order, warenkorb = null) {
        const fsStore = useFunctionsheetStore();

        if (warenkorb) {
            let fsSlot = "";
            for (const slot of fsStore.slots) {
                const [slotStart, slotEnd] = slot.split(" - ");

                if (
                    warenkorb.delivery_time > slotStart &&
                    warenkorb.delivery_time <= slotEnd
                ) {
                    fsSlot = `${slotStart} - ${slotEnd}`;
                }
            }
            return [warenkorb.delivery_time, fsSlot];
        }

        if (!order.meta_data) {
            console.error("this order has no meta_data");
        } else {
            let time = "";
            const type = order.meta_data.find(
                (item) => item.key == "delivery_type",
            ).value;
            if (type == "delivery") {
                const delivery_index = order.meta_data.findIndex(
                    (item) => item.key == "delivery_time",
                );
                if (delivery_index != -1)
                    time = order.meta_data[delivery_index].value;
            } else if (type == "pickup") {
                const pickup_index = order.meta_data.findIndex(
                    (item) => item.key == "pickup_time",
                );
                if (pickup_index != -1)
                    time = order.meta_data[pickup_index].value;
            }
            if (time) {
                // const regex = /^\d{1,2}:\d\d/gm;

                // let strippedTime = regex.exec(time)[0];

                // if (strippedTime) {
                //     let hour = Number(strippedTime.substring(0, 2)) - 1;
                //     let rest = strippedTime.substring(2, 5);
                //     hour = hour.toLocaleString("de", { minimumIntegerDigits: 2 });

                //     strippedTime = hour + rest;
                // }

                const [orderStart, _] = time.split(" - ");
                let fsSlot = "";
                for (const slot of fsStore.slots) {
                    const [slotStart, slotEnd] = slot.split(" - ");

                    if (orderStart > slotStart && orderStart <= slotEnd) {
                        fsSlot = `${slotStart} - ${slotEnd}`;
                    }
                }

                // return [strippedTime, time, fsSlot];
                return [time, fsSlot];
            }
            return ["-", "keine Angabe"];
        }
    }

    function getDeliveryNameFromOrder(order) {
        // if(order.data.status == 403) return ""; // current bugfix, needs to be reviewed
        if (
            order.meta_data.find((md) => md.key == "delivery_type")?.value ==
            "delivery"
        ) {
            return "Lieferung";
        } else if (
            order.meta_data.find((md) => md.key == "delivery_type")?.value ==
            "pickup"
        ) {
            return "Abholung";
        } else return "";
    }

    return { getTimeFromOrder, getDeliveryNameFromOrder };
}
